import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TradslagDTO } from "~app/features/virkeskop/models/mbf-models";
import { AtgardSkogsvardTradslagPlanta } from "~app/features/virkeskop/models/skogsvard/skogsvard-models";
import { SkogsvardTradslagService } from "~app/features/virkeskop/services/skogsvard-tradslag.service";
import { SkogsvardService } from "~app/features/virkeskop/services/skogsvard.service";

export interface ITradslagSkogsvardGrid {
    arealsandel?: string;
    id?: number;
    malplantorHa?: number;
    plantantal?: number;
    planttyp?: string;
    sekvensnummer?: number;
    skydd?: string;
    tradslag?: string;
}

@Component({
    selector: "rask-skogsvard-detaljer-for-tradslag",
    templateUrl: "./skogsvard-detaljer-for-tradslag.component.html",
    styleUrls: ["./skogsvard-detaljer-for-tradslag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective
    ]
})
export class SkogsvardDetaljerForTradslagComponent implements OnInit, OnDestroy {
    protected skogsvardtradslag: ITradslagSkogsvardGrid[] = [];

    private readonly ngDestroyed$ = new Subject<void>();
    private readonly skogsvardService = inject(SkogsvardService);
    private readonly skogsvardTradslagService = inject(SkogsvardTradslagService);

    private allatradslag: TradslagDTO[];
    private skogsvardTradslagLista: AtgardSkogsvardTradslagPlanta[] = [];

    ngOnDestroy(): void {
        this.ngDestroyed$.next();
        this.ngDestroyed$.complete();
    }

    ngOnInit(): void {
        combineLatest([
            this.skogsvardTradslagService.skogsvardTradslag$,
            this.skogsvardService.getTradslag()
        ]
        ).pipe(takeUntil(this.ngDestroyed$))
            .subscribe({
                next: x => {
                    this.skogsvardTradslagLista = x[0];
                    this.allatradslag = x[1];
                    this.mapTradslag();
                },
                error: () => {
                //
                }
            });
    }

    private getPercent(tal?: number) {
        if(tal) {
            return `${tal}%`;
        }
        return null;
    }

    private mapTradslag(): void {
        this.skogsvardtradslag.splice(0);
        this.skogsvardTradslagLista
            .forEach(x => {
                const tradslag = this.allatradslag.find(t => t.id === x.tradslagId);
                this.skogsvardtradslag
                    .push(
                        {
                            id: tradslag?.id,
                            sekvensnummer: tradslag?.sekvensnummer,
                            tradslag: tradslag?.externkod,
                            planttyp: x.planttyp,
                            skydd: x.plantskydd,
                            plantantal: x.plantantal,
                            arealsandel: this.getPercent(x.arealandel),
                            malplantorHa: x.malPlantorHA
                        });
            });

        this.skogsvardtradslag = [...this.skogsvardtradslag];
    }
}
